import createTaskType from '../../createTaskType';
import { cloneDeep, times } from "lodash";
import removePropertiesDeep from "@dyl/utils/removePropertiesDeep";
import PictureEditingEditor from "@dyl/task-types/PreA1/PictureEditing/Editor";

function Phase1Answers(index) {
    return times(3, (answerIndex) => ({
        is_correct_answer: answerIndex === 0,
        coordinates: {
            top: 0,
            left: 0
        },
    }));
}

function Phase2Answers(index) {
    return times(2, (answerIndex) => ({
        is_correct_answer: answerIndex === 0,
        coordinates: {
            top: 0,
            left: 0
        },
        color_hex_value: null,
        image_id: null
    }));
}


export default createTaskType   ({
    id: 'picture_editing',
    label: 'Picture Editing',
    skill: 'listening',
    v2: true,
    hasRubric: true,

    colors: [
        "#FF0000",
        "#009DFF",
        "#00FF0A",
        "#FFF500",
        "#FF9300",
        "#9D00FF",
        "#FA58F4"
    ],

    backgroundImages: { count: 1 },

    createItemsTemplate: () => times(7, i => ({
        // Example only section
        is_example: i % 4 === 0,
        ...(i % 4 === 0 && { rubric_id: '' }),
        phase: `PHASE_${Math.floor(i / 4) + 1}`,
        answers: i < 4 ? Phase1Answers(i) : Phase2Answers(i)
    })),
    editor: PictureEditingEditor,

    convertToUploadFormat(task, { isNew }) {
        task = cloneDeep(task);
        // Capitalize all colors
        task.colors = task.colors.map(c => c.toUpperCase());
        task.items = task.items.map(item => {
            item.answers = item.answers.map(answer => {
                answer.color_hex_value = answer?.color_hex_value?.toUpperCase?.() ?? null;
                return answer;
            })
            return item;
        })

        if (!isNew) {
            removePropertiesDeep(task, 'label');
        }

        return task;
    },
    rubric: {
        phaseCount: 2
    },

    getKeys: (item) => {
        const correct_answer = item.answers.find(x => x.is_correct_answer);
        if (item.phase === 'PHASE_1') {
            return [`${correct_answer.label} (${correct_answer.coordinates.top}, ${correct_answer.coordinates.left})`];
        } else {
            return [`[${correct_answer.color_hex_value}]; (${correct_answer.coordinates.top}, ${correct_answer.coordinates.left}); [${correct_answer.image_id}]`];
        }
    }
});